import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './index.scss';

class MyTable extends Component {
	constructor(props) {
		super(props);
		this.state = { data: this.props.data, columns: this.props.columns, pages: this.props.pages };
	}

	static getDerivedStateFromProps(nextProps, prevState){
		if(prevState.data !== nextProps.data){
			return { data: nextProps.data, columns: prevState.columns, pages: nextProps.pages };
		}
		return null
	}

	render() {
		return (
			<div>
				<ReactTable
					className="-striped -highlight reactTable"
					data={this.state.data}
					pages={this.state.pages}
					columns={this.state.columns}
					defaultSorted={[{ id: "employee_code", desc: false }]}
					defaultPageSize={10}
					showPagination={true}
					showPaginationTop={false}
					showPaginationBottom={true}
					manual
					onFetchData={this.props.handleFetchData}
				/>
			</div>
		);
	}
}

export default MyTable;


// WEBPACK FOOTER //
// ./src/components/MultiSelectTable/ReportTable.jsx